export const languageConstants = {
  AVAILABLE_LANGUAGE_LIST_LOADING: 'AVAILABLE_LANGUAGE_LIST_LOADING',
  AVAILABLE_LANGUAGE_LIST_SUCCESS: 'AVAILABLE_LANGUAGE_LIST_SUCCESS',
  AVAILABLE_LANGUAGE_LIST_FAILURE: 'AVAILABLE_LANGUAGE_LIST_FAILURE'
};
